// src/Pages/Footer.js
import React from "react";
import { FaGithub, FaLinkedin, FaTwitter, FaEnvelope, FaWhatsapp } from "react-icons/fa";
import { Link } from "react-router-dom";

const Footer = ({ footerVisible = true, contactNumber = "+2348029958684" }) => {
  return (
    <footer
      className={`bg-blue-600 text-white w-full transition-transform duration-300 ${
        footerVisible ? "translate-y-0" : "translate-y-full"
      }`}
    >
      {/* Top Section */}
      <div className="max-w-7xl mx-auto px-6 py-10 grid md:grid-cols-3 gap-6 text-sm">
        {/* Company Info */}
        <div>
          <p className="font-semibold text-yellow-300">
            Teemah Smart Technology Solution
          </p>
          <p className="mt-2 text-gray-200">
            Learning that meets you where you are — and takes you where you want
            to go.
          </p>
        </div>

        {/* Contact */}
        <div>
          <p className="font-semibold text-yellow-300">Contact</p>
          <p className="mt-2 text-gray-200">
            Email: <a href="mailto:hello@teemahsmart.com" className="hover:underline">hello@teemahsmart.com</a>
          </p>
          <p className="text-gray-200">Phone/WhatsApp: {contactNumber}</p>
        </div>

        {/* Quick Links */}
        <div>
          <p className="font-semibold text-yellow-300">Quick Links</p>
          <ul className="mt-2 space-y-1">
            <li>
              <a href="#programs" className="hover:underline">
                Programs
              </a>
            </li>
            <li>
              <a href="#how" className="hover:underline">
                Free Assessment (How it works)
              </a>
            </li>
            <li>
              <a href="#social" className="hover:underline">
                Facebook Pages
              </a>
            </li>
          </ul>
        </div>
      </div>

      {/* Social Icons */}
      <div className="flex justify-center space-x-6 mb-4">
        <Link
          to="https://github.com/teemahlwittyswiffyfwarry"
          target="_blank"
          rel="noopener noreferrer"
          className="text-yellow-400 hover:text-white"
        >
          <FaGithub size={24} />
        </Link>
        <Link
          to="https://linkedin.com/in/oluwayemisi-oladosu"
          target="_blank"
          rel="noopener noreferrer"
          className="text-yellow-400 hover:text-white"
        >
          <FaLinkedin size={24} />
        </Link>
        <Link
          to="https://wa.me/+2348029958684"
          target="_blank"
          rel="noopener noreferrer"
          className="text-yellow-400 hover:text-white"
        >
          <FaWhatsapp size={24} />
        </Link>
        <Link
          to="mailto:oladosuoluwayemisi@gmail.com"
          className="text-yellow-400 hover:text-white"
        >
          <FaEnvelope size={24} />
        </Link>
      </div>

      {/* Bottom Section */}
      <div className="text-xs text-center text-gray-300 pb-6">
        © {new Date().getFullYear()} Teemah Smart. All Rights Reserved.
      </div>
    </footer>
  );
};

export default Footer;
